import { MenuItem } from '@card-software/library';

export const MENU_ITEMS: MenuItem[] = [
  {
    displayName: 'Assets',
    routerLink: '/assets',
    redirect: true,
  },
  {
    displayName: 'Administration',
    routerLink: '/admin',
    redirect: false,
    children: [
      {
        displayName: 'Asset Details',
        routerLink: 'admin/assets-details',
        redirect: true,
      },
      {
        displayName: 'Sites',
        routerLink: 'admin/sites',
        redirect: true,
      },
    ],
  },
];
